import React from "react"
import {
  Grid as GluestackGrid,
  GridItem as GluestackGridItem,
} from "./gluestack/grid"

export interface GridProps extends React.ComponentProps<typeof GluestackGrid> {
  className?: string
}

export interface GridItemProps
  extends React.ComponentProps<typeof GluestackGridItem> {
  className?: string
}

export const Grid = ({ children, className, ...props }: GridProps) => {
  return (
    <GluestackGrid className={className} {...props}>
      {children}
    </GluestackGrid>
  )
}

export const GridItem = ({ children, className, ...props }: GridItemProps) => {
  return (
    <GluestackGridItem className={className} {...props}>
      {children}
    </GluestackGridItem>
  )
}
